import { createUniqKey }     from 'Utils';

export interface ITicketSummary {
  eventName: string,
  ticketType: string,
  systemTax: string,
  amount: number,
  total: number,
  fee: number,
  netto: number,
}

export interface ISummary {
  total: number,
  amount: number,
  netto: number,
  fee: number,
  shippingCost: number,
  shippingTax: number,
  ticketSummary: Record<string, ITicketSummary>
}

export interface IOrganisationInvoice {
  id: string,
  invoiceNumber: string,
  invoiceDate: number|null,
  total: number|null,
  fee: number|null,
  tax: number|null,
  netto: number|null,
  summary: ISummary|null,
  from: number|null,
  to: number|null,
}

export class OrganisationInvoice {
    public _key: string;
    public id: string;
    public invoiceNumber: string;
    public invoiceDate: Date|null;
    public total: number|null;
    public fee: number|null;
    public tax: number|null;
    public netto: number|null;
    public summary: ISummary|null;
    public from: Date|null;
    public to: Date|null;

    constructor(data: IOrganisationInvoice) {
      this._key = createUniqKey();
      this.id = data.id;

      this.invoiceNumber = data.invoiceNumber;
      this.invoiceDate = data.invoiceDate ? new Date(data.invoiceDate * 1000) : null;
      this.from = data.from ? new Date(data.from * 1000) : null;
      this.to = data.to ? new Date(data.to * 1000) : null;
      this.total = data.total;
      this.fee = data.fee;
      this.tax = data.tax;
      this.netto = data.netto;
      this.summary = data.summary || null;

    }
}

export const createNewOrganisationInvoice = (data: Partial<IOrganisationInvoice> = {}): OrganisationInvoice => new OrganisationInvoice({
  id: data.id || 'new',
  invoiceNumber: data.invoiceNumber || '',
  invoiceDate: data.invoiceDate || null,
  total: data.total || null,
  fee: data.fee || null,
  tax: data.tax || null,
  netto: data.netto || null,
  summary: data.summary || null,
  from: data.from || null,
  to: data.to || null,
});
